const CalendarUtils = {
  DAY_NUMBER: {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
  },

  DAYS: [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ],

  formatYmd(date) {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
  },

  ymdToDmy(ymd) {
    if (!ymd) return ymd;
    const parts = String(ymd).split("-");
    if (parts.length !== 3) return ymd;
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  },

  getEarliestDate(dates) {
    if (!dates || dates.length === 0) return null;
    return [...new Set(dates)].sort()[0];
  },

  getLatestDate(dates) {
    if (!dates || dates.length === 0) return null;
    return [...new Set(dates)].sort().at(-1);
  },
};
